import {
  VerifyOtpCodeBody,
  ResendOtpCodeBody,
  Tokens,
  RefreshTokensBody,
  SignInCodeBody,
  SignInCodeResponse,
  ChangePasswordBody,
  ChangePinBody,
  VerifyPinCodeBody,
} from 'common/models';
import http from 'core/services/api';

class AuthRepository {
  signIn = async (body: SignInCodeBody) =>
    http.fetch((axios, signal) =>
      axios.post<SignInCodeResponse>('/auth/sign-in', body, { signal })
    );

  // TODO: add this endpoint ot the excludedEndpoints in the http client
  resendOtpCode = async ({ otpAccessToken }: ResendOtpCodeBody) =>
    http.fetch((axios, signal) =>
      axios.post<object>(
        '/auth/send-otp',
        {},
        {
          signal,
          headers: {
            Authorization: `Bearer ${otpAccessToken}`,
          },
        }
      )
    );

  verifyOtpCode = async ({ otp, otpAccessToken }: VerifyOtpCodeBody) =>
    http.fetch((axios, signal) =>
      axios.post<Tokens>(
        '/auth/verify-otp',
        { otp },
        {
          signal,
          headers: {
            Authorization: `Bearer ${otpAccessToken}`,
          },
        }
      )
    );

  verifyPin = async (body: VerifyPinCodeBody) =>
    http.fetch((axios, signal) =>
      axios.post<Tokens>('/auth/verify-pin', body, {
        signal,
      })
    );

  refreshTokens = async (body: RefreshTokensBody) =>
    http.fetch(
      (axios, signal) =>
        axios.post<Pick<Tokens, 'accessToken'>>('/auth/refresh', body, {
          signal,
        }),
      false
    );

  changePassword = async (body: ChangePasswordBody) =>
    http.fetch((axios, signal) =>
      axios.post<void>('/auth/change-password', body, { signal })
    );

  changePin = async (body: ChangePinBody) =>
    http.fetch((axios, signal) =>
      axios.post<void>('/auth/change-pin', body, { signal })
    );
}

export const authRepository = new AuthRepository();
